import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingNav from '@/components/landing/LandingNav';
import Hero from '@/components/landing/Hero';
import InteractiveQuestionDemo from '@/components/landing/InteractiveQuestionDemo';
import FeatureShowcase from '@/components/landing/FeatureShowcase';
// Pricing is hidden while we collect early-adopter emails instead of driving signups.
// import PricingTeaser from '@/components/landing/PricingTeaser';
import FinalCTA from '@/components/landing/FinalCTA';
import WaitlistSection from '@/components/landing/WaitlistSection';
import LandingFooter from '@/components/landing/LandingFooter';
import { track, type WaitlistCtaSource } from '@/lib/analytics';

export default function LandingPage() {
  const { hash } = useLocation();

    const scrollToWaitlist = (source: WaitlistCtaSource) => {
    track('waitlist_cta_clicked', { source });
    document
      .getElementById('waitlist')
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useLayoutEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'instant' });
      return;
    }
    const el = document.getElementById(hash.slice(1));
    if (el) {
      el.scrollIntoView({ block: 'start', behavior: 'instant' });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-cream">
      <LandingNav onOpenWaitlist={scrollToWaitlist} />
      <main>
        <Hero onOpenWaitlist={scrollToWaitlist} />
        <InteractiveQuestionDemo onOpenWaitlist={scrollToWaitlist} />
        <FeatureShowcase />
        {/* <PricingTeaser /> */}
        <WaitlistSection />
        <FinalCTA onOpenWaitlist={scrollToWaitlist} />
      </main>
      <LandingFooter />
    </div>
  );
}
